import React, { useState, useEffect } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function CreateMegaScholarship() {

  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  // subject => { subject_id, questions }
  const [subjectConfig, setSubjectConfig] = useState([]);

  const [form, setForm] = useState({
    title: "",
    exam_date: "",
    start_time: "10:00",
    end_time: "13:00",
    entry_fee: 499
  });

  const nav = useNavigate();

  // Load Classes
  useEffect(() => {
    api.get("/admin/classes").then(res => setClasses(res.data || []));
  }, []);

  // Load subjects when class changes
  useEffect(() => {
    if (!selectedClass) {
      setSubjects([]);
      setSubjectConfig([]);
      return;
    }

    api.get(`/admin/subjects?class_id=${selectedClass}`).then(res => {
      const data = res.data || [];

      // create config with default question count = 1
      setSubjectConfig(data.map(s => ({
        subject_id: s.id,
        name: s.name,
        selected: false,
        questions: 1
      })));

      setSubjects(data);
    });

  }, [selectedClass]);


  const toggleSubject = (id) => {
    setSubjectConfig(prev =>
      prev.map(s => s.subject_id === id ? { ...s, selected: !s.selected } : s)
    );
  };

  const updateQuestionCount = (id, value) => {
    setSubjectConfig(prev =>
      prev.map(s =>
        s.subject_id === id ? { ...s, questions: Number(value) } : s
      )
    );
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedSubjects = subjectConfig.filter(s => s.selected);

    if (selectedSubjects.length === 0) {
      alert("कम से कम 1 subject select करना जरूरी है।");
      return;
    }

    const payload = {
      ...form,
      class_id: Number(selectedClass),
      subject_ids: selectedSubjects.map(s => s.subject_id),
      question_count: Object.fromEntries(
        selectedSubjects.map(s => [s.subject_id, s.questions])
      )
    };

    try {
      const res = await api.post("/admin/mega_scholarship/create", payload);

      const examId = res.data.exam_id || res.data.id;

      alert("🎉 Exam Successfully Created!");
      nav(`/admin/mega-scholarship/${examId}/add-questions`);

    } catch (err) {
      alert(err.response?.data?.error || "Something went wrong while creating exam!");
    }
  };


  return (
    <div style={{ background: "#0f172a", minHeight: "100vh", padding: 40, color: "white" }}>
      
      <button
        onClick={() => nav(-1)}
        style={{ padding: "12px 24px", background: "#1e293b", border: "none", borderRadius: 12, color: "white", marginBottom: 30 }}>
        ⬅ Back
      </button>

      <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 40, textAlign: "center" }}>
        Create Mega Scholarship Exam
      </h1>

      <form onSubmit={handleSubmit} style={{ maxWidth: 600, margin: "0 auto" }}>

        {/* Title */}
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: "block", marginBottom: 8 }}>Exam Title</label>
          <input required placeholder="e.g. Mega Scholarship 2025"
            style={{ width: "100%", padding: 14, borderRadius: 8, background: "#1e293b", border: "1px solid #475569", color: "white" }}
            value={form.title}
            onChange={e => setForm({ ...form, title: e.target.value })} />
        </div>

        {/* Class + Fee */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 24 }}>
          
          <div>
            <label style={{ display: "block", marginBottom: 8 }}>Class</label>
            <select required
              style={{ width: "100%", padding: 14, borderRadius: 8, background: "#1e293b", border: "1px solid #475569", color: "white" }}
              value={selectedClass}
              onChange={e => setSelectedClass(e.target.value)}>
              
              <option value="">Select Class</option>
              {classes.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ display: "block", marginBottom: 8 }}>Entry Fee (₹)</label>
            <input type="number" required
              style={{ width: "100%", padding: 14, borderRadius: 8, background: "#1e293b", border: "1px solid #475569", color: "white" }}
              value={form.entry_fee}
              onChange={e => setForm({ ...form, entry_fee: Number(e.target.value) })} />
          </div>

        </div>



        {/* Subjects & Question Count */}
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: "block", marginBottom: 12, fontWeight: 600 }}>Select Subjects & Question Count</label>

          {subjectConfig.map(s => (
            <div key={s.subject_id} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>

              <button type="button" onClick={() => toggleSubject(s.subject_id)}
                style={{
                  padding: "10px 20px",
                  borderRadius: 20,
                  background: s.selected ? "#f59e0b" : "#334155",
                  color: "white",
                  border: "none",
                  fontWeight: 600,
                  minWidth: 100,
                  textAlign: "center"
                }}>
                {s.name}
              </button>

              {s.selected && (
                <input
                  type="number"
                  min="1"
                  placeholder="Questions"
                  style={{
                    padding: 12,
                    width: 120,
                    background: "#1e293b",
                    border: "1px solid #475569",
                    borderRadius: 8,
                    color: "white"
                  }}
                  value={s.questions}
                  onChange={e => updateQuestionCount(s.subject_id, e.target.value)}
                />
              )}

            </div>
          ))}

        </div>



        {/* Date & Time */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 20, marginBottom: 40 }}>
          
          <div>
            <label>Exam Date</label>
            <input type="date" required
              style={{ width: "100%", padding: 14, borderRadius: 8, background: "#1e293b", border: "1px solid #475569", color: "white" }}
              value={form.exam_date}
              onChange={e => setForm({ ...form, exam_date: e.target.value })} />
          </div>

          <div>
            <label>Start Time</label>
            <input type="time" required value={form.start_time}
              style={{ width: "100%", padding: 14, borderRadius: 8, background: "#1e293b", border: "1px solid #475569", color: "white" }}
              onChange={e => setForm({ ...form, start_time: e.target.value })} />
          </div>

          <div>
            <label>End Time</label>
            <input type="time" required value={form.end_time}
              style={{ width: "100%", padding: 14, borderRadius: 8, background: "#1e293b", border: "1px solid #475569", color: "white" }}
              onChange={e => setForm({ ...form, end_time: e.target.value })} />
          </div>

        </div>

        <button type="submit"
          style={{ width: "100%", padding: 18, background: "#f59e0b", color: "white", border: "none", borderRadius: 12, fontSize: 18, fontWeight: 700 }}>
          🚀 Create Exam & Add Questions
        </button>

      </form>
    </div>
  );
}
